import { render } from "./CustomDialog.vue?vue&type=template&id=818e47e0&ts=true"
import script from "./CustomDialog.vue?vue&type=script&lang=ts"
export * from "./CustomDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__